// removed by extract-text-webpack-plugin
module.exports = {"title-modal":"app-pages-Library-SalesType-LibraryDeleteModal-__style___T7gCY","dialog":"app-pages-Library-SalesType-LibraryDeleteModal-__style___26_SD","header-delete":"app-pages-Library-SalesType-LibraryDeleteModal-__style___17DT3"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Library/SalesType/LibraryDeleteModal/style.css
// module id = 2455
// module chunks = 0